import { createFileRoute, redirect } from '@tanstack/react-router';

/** Legacy Clerk path; custom sign-up does not use a separate phone step. */
export const Route = createFileRoute('/signup/verify-phone-number')({
  beforeLoad: () => {
    throw redirect({ to: '/signup', replace: true });
  },
  component: () => null,
});
